import React from "react";
import { RETRO_CHART_MARGINS } from "./performanceChartAppearance";
import "./PerformanceChartSurface.css";

interface PerformanceChartSurfaceProps {
  containerRef: React.RefObject<HTMLDivElement | null>;
  svgRef: React.RefObject<SVGSVGElement | null>;
  tooltipRef: React.RefObject<HTMLDivElement | null>;
  selectedPeriod: string;
  legend?: React.ReactNode;
  portfolioName?: string;
  showWatermark?: boolean;
  ariaLabel?: string;
  plotHeight?: number;
}

/** Visual shell only. The existing D3 hook owns the SVG and hover behavior. */
export default function PerformanceChartSurface({
  containerRef,
  svgRef,
  tooltipRef,
  selectedPeriod,
  legend,
  portfolioName,
  showWatermark = true,
  ariaLabel = "Cumulative performance",
  plotHeight,
}: PerformanceChartSurfaceProps) {
  return (
    <div ref={containerRef} className={`retro-performance-chart relative w-full ${plotHeight === undefined ? "aspect-[16/9]" : ""}`}
      style={plotHeight === undefined ? undefined : { height: plotHeight + RETRO_CHART_MARGINS.top + RETRO_CHART_MARGINS.bottom }}
      data-chart-visual-style="retro">
      <div className="pointer-events-none absolute inset-x-0 top-0 flex h-5 items-center justify-between gap-2 bg-retro-header px-[14px] text-xs font-bold leading-none text-retro-ink">
        <div className="flex min-w-0 items-center gap-3">
          {portfolioName && <span className="truncate" title={portfolioName}>{portfolioName}</span>}
          <span className="shrink-0">CUMULATIVE RETURN (%)</span>
        </div>
        <span className="shrink-0">{selectedPeriod}</span>
      </div>
      <svg ref={svgRef} role="img" aria-label={ariaLabel} className="block" />
      {legend && (
        <div
          data-chart-legend
          className="pointer-events-none absolute z-10 flex flex-wrap items-center gap-x-4 gap-y-1"
          style={{ top: RETRO_CHART_MARGINS.top + 6, left: RETRO_CHART_MARGINS.left + 7, right: RETRO_CHART_MARGINS.right + 6 }}
        >
          {legend}
        </div>
      )}
      {showWatermark && (
        <div
          aria-hidden="true"
          data-chart-watermark
          className="retro-chart-watermark pointer-events-none absolute z-[5] select-none opacity-30 grayscale"
          style={{ right: RETRO_CHART_MARGINS.right + 12, bottom: RETRO_CHART_MARGINS.bottom + 15 }}
        >
          <div className="retro-watermark-art"><img src="/favicon.png" alt="" /></div>
          <div className="retro-watermark-wordmark"><img data-testid="performance-chart-watermark-wordmark" src="/logo.png" alt="" /></div>
          <span>www.runplutus.com</span>
        </div>
      )}
      <div data-html2canvas-ignore ref={tooltipRef} className="pointer-events-none absolute z-[1000] hidden border border-retro-frame bg-retro-paper px-3 py-2 text-retro-ink empty:invisible" />
    </div>
  );
}
